import { WinDerivSelection } from "../../interfaces/dtos/common";
import { Deriv, Deriv_Selection_Calculated, DerivCalculated, DerivMapping } from "../../interfaces/dtos/deriv"
import { getOverround, getWinDerivCommonCalculated } from "../common/commonCalculated";

export const getDerivCalculated = (deriv: Deriv, derivMappings: DerivMapping[]): DerivCalculated => {
    return {
        ...getWinDerivCommonCalculated(deriv),
        groupKey: groupKey(deriv),
        selections: selections(deriv, derivMappings)
    }
}

const groupKey = (deriv: Deriv): string => {
    return `${deriv.marketName}_${deriv.marketType}_${createGroupSelectionsKey(deriv)}`;
}

const createGroupSelectionsKey = (deriv: Deriv): string => {
    if (!deriv.selections) { return ""; };
    const groupRunnerKeys = deriv.selections.map(s => createGroupRunnersKey(s));
    return groupRunnerKeys
        .toSorted((a, b) => a < b ? -1 : 1)
        .join("_");
}

const createGroupRunnersKey = (selection: WinDerivSelection) => {
    if (!selection.runnerIds) { return "" };
    return selection.runnerIds
        .toSorted((a, b) => a < b ? -1 : 1)
        .join("|");
}

const selections = (deriv: Deriv, derivMappings: DerivMapping[]): Deriv_Selection_Calculated[] => {
    if (!deriv.selections) { return []; }
    const derivMapping = derivMappings.find(dm =>
        dm.marketType.toLowerCase() === deriv.marketType?.toLowerCase() ||
        dm.marketTypeSIS.toLowerCase() === deriv.marketType?.toLowerCase()
    );
    return deriv.selections.map((selection, i) => mapSelection(selection, i, derivMapping));
}

const mapSelection = (selection: WinDerivSelection, iteration: number, derivMapping?: DerivMapping) => {
    const showRunnerInfo = derivMapping === undefined || derivMapping?.selectionType === "runners";
    const selectionKey = showRunnerInfo ?
        `${selection.runnerIds?.toSorted((a, b) => ((a < b ? -1 : 1))).map(s => s)},` :
        mapDerivSelection(iteration, derivMapping);
    const selections = showRunnerInfo ? selection.runnerIds : derivMapping?.selections;
    return {
        selectionKey: selectionKey,
        showRunnerInfo,
        selections,
        priceFract: selection.priceFract,
        overround: getOverround(selection)
    }
}

const mapDerivSelection = (iteration: number, derivMapping?: DerivMapping) => {
    return derivMapping?.selections && derivMapping.selections?.length > iteration ? derivMapping.selections[iteration] : '';
}
